import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DashboardModule } from "./_features/dashboard/dashboard.module";
const routes: Routes = [
  {
    path: "",
    loadChildren: "./_features/dashboard/dashboard.module#DashboardModule",
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes), DashboardModule],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor() {
    console.log("AppRoutingModule");
  }
}
